import { Outlet, createFileRoute } from '@tanstack/react-router'

import { AuthModes } from '@/features/auth/policy'

/**
 * Pathless layout for event-host routes (flat URLs: /jornadas, /auth/sign-in, /sign-out).
 * Leaf routes override auth via staticData (BOOTSTRAP for auth/sign-out, REQUIRED for app pages).
 */
export const Route = createFileRoute('/_event')({
  staticData: {
    auth: {
      mode: AuthModes.REQUIRED,
      requiresDigitalProductId: true
    }
  },
  component: () => <Outlet />
})
